import { render, staticRenderFns } from "./OriginalOrder.vue?vue&type=template&id=29a32993&scoped=true&"
import script from "./OriginalOrder.vue?vue&type=script&lang=js&"
export * from "./OriginalOrder.vue?vue&type=script&lang=js&"
import style0 from "./OriginalOrder.vue?vue&type=style&index=0&id=29a32993&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a32993",
  null
  
)

export default component.exports